module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-BoldItalic.eb964f9.woff2";